import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
// TODO: fucking node env always development so fuck it
//console.log(process.env.NODE_ENV)
application.warnings = true //process.env.NODE_ENV === 'development'
application.debug    = false //process.env.NODE_ENV === 'development'
window.Stimulus      = application

export { application }
